module.exports = __webpack_public_path__ + "img/highlight_solution.8674c09f.svg";